// export an new function called handle403s
//in that function, trigger popup that sya your logged out then give them an option to login - already exists.

// got through all the components, and any component that has a fecth in it, we need to check if the fecth response is a 403, if it is, then we need to trigger function.
// Basically each component needs to import this function at the top of every element with a fetch function, then place right above the const $response = await fetch section
// and place/call it  inside an if statement that checks if the $response.status = 403
// Do not include it for Loginlogout, login widgets, EmailConfimartion, EmailVerify, Logout, LoginInForm  and SignUpForm

export function handle403s(){
    console.log('403s handled');
    // display the dialog here
    const sessionComponent = document.querySelector('allin-session');

    if (!sessionComponent || !sessionComponent.shadowRoot) {
        return;
    }

    const warningDialog = sessionComponent.shadowRoot.querySelector('#session-almost-expired');
    const expiredDialog = sessionComponent.shadowRoot.querySelector('#session-expired');

    // Close the warning dialog if it's currently open
    if (warningDialog?.open) {
        warningDialog.close();
    }

    // Don't try to reopen the expired dialog
    if (expiredDialog?.open) {
        return;
    }

    // Expire the client cookie
    document.cookie = "allin_uid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";

    // Display the existing session expired dialog
    expiredDialog?.showModal();
}